import Cookies from "js-cookie";
import {
  VISITOR_COOKIE_NAME,
  VISITOR_COOKIE_EXPIRY_DAYS,
} from "./visitorCookie";

const LEGACY_VISITOR_STORAGE_KEY = "visitor_id";

function persistVisitorId(id: string) {
  Cookies.set(VISITOR_COOKIE_NAME, id, {
    expires: VISITOR_COOKIE_EXPIRY_DAYS,
    sameSite: "lax",
  });

  return id;
}

export function resolveVisitorId(): string {
  const legacyId = localStorage.getItem(LEGACY_VISITOR_STORAGE_KEY);
  const cookieId = Cookies.get(VISITOR_COOKIE_NAME);

  if (legacyId) {
    return legacyId === cookieId ? legacyId : persistVisitorId(legacyId);
  }

  if (cookieId) return cookieId;

  return persistVisitorId(crypto.randomUUID());
}
